import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import useStyles from '../common/styles';

import i18n from "i18next";
import { useTranslation } from "react-i18next";

import InfoKor1 from '../assets/info_kor_1.png';
import InfoKor2 from '../assets/info_kor_2.png';
import InfoEng1 from '../assets/info_eng_1.png';
import InfoEng2 from '../assets/info_eng_2.png';
import LogoImage from '../assets/logo.webp';

import "/node_modules/flag-icons/css/flag-icons.min.css";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import { useFormik } from 'formik';
import { backendURL } from '../common/api';
import { useState } from 'react';
import dayjs from 'dayjs';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';

// import { MuiTelInput, MuiTelInputCountry } from 'mui-tel-input'
import { Theme } from '@mui/material';

export default function Invitation({ participantHash }: { participantHash?: string }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const [isArrivalDisabled, setIsArrivalDisabled] = useState<boolean | null>(null);
  const [isDepartureDisabled, setIsDepartureDisabled] = useState<boolean | null>(null);
  const [isValetUsed, setIsValetUsed] = useState<boolean | null>(null);
  const [isSpecialMealDisabled, setIsSpecialMealDisabled] = useState<boolean | null>(null);
  const [isNationalityRok, setIsNationalityRok] = useState<boolean | null>(null);
  const [isEventInfoOpen, setIsEventInfoOpen] = useState(false);
  const [isPrivacyAgreed, setIsPrivacyAgreed] = useState(false);
  const [isThirdPartyAgreed, setIsThirdPartyAgreed] = useState(false);
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const openAlertDialog = (title: string, message: string) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setIsAlertDialogOpen(true);
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      nameEng: "",
      gender: "",
      birthdate: "",
      nationality: "",
      company: "",
      position: "",
      address: "",
      officePhone: "",
      mobilePhone: "",
      flightDeparture: "",
      flightArrival: "",
      valetVehicleNumber: "",
      gloveSize: "",
      gloveLeftHanded: false,
      specialMeal: "",
    },
    onSubmit: (form) => {
      form.birthdate = dayjs(form.birthdate).format('YYYY-MM-DD');

      const requiredFields = new Map<string, string>([
        ['name', t('name')],
        ['gender', t('gender')],
        ['nameEng', t('nameEng')],
        ['birthdate', t('birth')],
        ['nationality', t('nationality')],
        ['company', t('company')],
        ['position', t('position')],
        ['address', t('address')],
        ['officePhone', t('officePhone')],
        ['mobilePhone', t('mobilePhone')],
        ['gloveSize', t('gloveSize')],
        ['specialMeal', t('specialMeal')],
        ['flightDeparture', t('flightDeparture')],
        ['flightArrival', t('flightArrival')],
        ['valetVehicleNumber', t('valetVehicleNumber')],
      ]);

      const objectToSubmit = {
        name: form.name,
        gender: form.gender,
        nationality: form.nationality,
        company: form.company,
        position: form.position,
        address: form.address,
        name_eng: form.nameEng,
        birthdate: form.birthdate,
        office_phone: form.officePhone,
        mobile_phone: form.mobilePhone,
        flight: '이용',
        flight_departure: form.flightDeparture,
        flight_arrival: form.flightArrival,
        glove_size: form.gloveSize,
        glove_left_handed: form.gloveLeftHanded,
        special_meal: form.specialMeal,
        valet_service: isValetUsed === null ? '' : isValetUsed ? '이용' : '미이용',
        valet_vehicle_number: form.valetVehicleNumber,
      };

      if (i18n.language === 'en') {
        requiredFields.delete('nameEng');
      } else if (isNationalityRok) {
        objectToSubmit.nationality = '대한민국';
        requiredFields.delete('nameEng');
        requiredFields.delete('nationality');
      }

      if (isDepartureDisabled) {
        objectToSubmit.flight_departure = '김포발 → 제주행 10/28(수) 06:20';
        requiredFields.delete('flightDeparture');
      }

      if (isArrivalDisabled) {
        objectToSubmit.flight_arrival = '제주발 → 김포행 10/28(수) 20:45';
        requiredFields.delete('flightArrival');
      }

      if (isValetUsed === false) {
        objectToSubmit.valet_vehicle_number = '';
        requiredFields.delete('valetVehicleNumber');
      }

      if (isSpecialMealDisabled === true) {
        objectToSubmit.special_meal = '없음';
        requiredFields.delete('specialMeal');
      }

      const missingFields = Array.from(requiredFields.entries())
        .filter(([field]) => !String(form[field as keyof typeof form] || '').trim())
        .map(([, label]) => label);

      if (missingFields.length) {
        openAlertDialog(t('error'), `${t('formError')} ${missingFields.join(', ')}`);
        return;
      }

      if (isValetUsed === null || isSpecialMealDisabled === null || isDepartureDisabled === null || isArrivalDisabled === null || (i18n.language !== 'en' && isNationalityRok === null)) {
        openAlertDialog(t('error'), t('selectionError'));
        return;
      }

      if (!isPrivacyAgreed || !isThirdPartyAgreed) {
        openAlertDialog(t('error'), t('agreementError'));
        return;
      }

      if (!participantHash) {
        openAlertDialog(t('error'), t('invalidInvitation'));
        return;
      }

      fetch(`${backendURL}s-oil-api/participants/${participantHash}`, {
          method: "PUT",
          body: JSON.stringify(objectToSubmit),
          headers: {
            'content-type': 'application/json',
          }
        })
          .then(async response => {
            const responseBody = await response.json().catch(() => ({}));
            if (!response.ok) {
              console.error('Submission failed:', response.status, responseBody);
              throw new Error(t('networkError'));
            }
            return responseBody;
          })
          .then(response => {
            if (response.error) {
              openAlertDialog(t('error'), response.error);
            } else {
              openAlertDialog(t('notification'), t('submitSuccess'));
            }
          })
          .catch(error => {
            openAlertDialog(t('error'), t(error.message));
          })
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className={classes.paper}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8, marginBottom: 12 }}>
          <img src={LogoImage} alt="logo" style={{ width: 'min(62vw, 220px)', height: 'auto', display: 'block' }} />
        </div>
        <Box sx={{ width: '100%', maxWidth: 280, mt: 1, mb: 2, mx: 'auto' }}>
          <Stack direction="row" justifyContent="center" spacing={1.25}>
            <Button
              type="button"
              variant={i18n.language === 'ko' ? 'contained' : 'outlined'}
              onClick={() => i18n.changeLanguage('ko')}
              sx={{
                minWidth: 120,
                fontWeight: 700,
                color: i18n.language === 'ko' ? '#ffffff' : '#223329',
                backgroundColor: i18n.language === 'ko' ? 'var(--s-oil-bg-mid)' : '#ffffff',
                borderColor: 'var(--s-oil-bg-mid)',
                '&:hover': {
                  backgroundColor: i18n.language === 'ko' ? 'var(--s-oil-bg-top)' : 'rgba(19, 100, 51, 0.08)',
                  borderColor: 'var(--s-oil-bg-top)',
                },
              }}
            >
              <span className="fi fi-kr" style={{ marginRight: 8 }} />
              한국어
            </Button>
            <Button
              type="button"
              variant={i18n.language === 'en' ? 'contained' : 'outlined'}
              onClick={() => i18n.changeLanguage('en')}
              sx={{
                minWidth: 120,
                fontWeight: 700,
                color: i18n.language === 'en' ? '#ffffff' : '#223329',
                backgroundColor: i18n.language === 'en' ? 'var(--s-oil-bg-mid)' : '#ffffff',
                borderColor: 'var(--s-oil-bg-mid)',
                '&:hover': {
                  backgroundColor: i18n.language === 'en' ? 'var(--s-oil-bg-top)' : 'rgba(19, 100, 51, 0.08)',
                  borderColor: 'var(--s-oil-bg-top)',
                },
              }}
            >
              <span className="fi fi-us" style={{ marginRight: 8 }} />
              English
            </Button>
          </Stack>
        </Box>
        <Typography variant="h6" gutterBottom textAlign="center" sx={{ whiteSpace: 'pre-wrap', color: '#ffffff', mb: 1.5 }}>
          {t("formTitle")}
        </Typography>
        <Card className={classes.form}>
          <CardContent>
            <Box sx={{ mb: 2, border: '1px solid var(--s-oil-border)', borderRadius: 2, overflow: 'hidden', backgroundColor: 'var(--s-oil-surface)' }}>
              <Box sx={{ px: 2, py: 1.25, backgroundColor: 'var(--s-oil-bg-mid)', color: '#ffffff', fontWeight: 700 }}>
                {t('eventDetailsTitle')}
              </Box>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'minmax(120px, 1fr) minmax(0, 3fr)',
                  '& > div': {
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 1.25, md: 1.5 },
                    borderBottom: '1px solid var(--s-oil-border)',
                  },
                  '& > div:nth-of-type(odd)': {
                    backgroundColor: 'var(--s-oil-surface-2)',
                    fontWeight: 700,
                    borderRight: '1px solid var(--s-oil-border)',
                    whiteSpace: 'normal',
                    wordBreak: 'keep-all',
                    overflowWrap: 'normal',
                    lineHeight: 1.35,
                  },
                  '& > div:nth-of-type(even)': {
                    backgroundColor: 'var(--s-oil-surface)',
                  },
                }}
              >
                <div>{t('eventDateLabel')}</div>
                <div>{t('eventDateValue')}</div>
                <div>{t('eventLocationLabel')}</div>
                <div>{t('eventLocationValue')}</div>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card className={classes.form} sx={{ mt: 2 }}>
          <CardContent>
            <Box sx={{ border: '1px solid var(--s-oil-border)', borderRadius: 2, overflow: 'hidden', backgroundColor: 'var(--s-oil-surface)' }}>
              <Box sx={{ px: 2, py: 1.25, backgroundColor: 'var(--s-oil-bg-mid)', color: '#ffffff', fontWeight: 700 }}>
                {t('customerInfoTitle')}
              </Box>
              <List sx={{
                display: 'grid',
                gridTemplateColumns: 'minmax(120px, 1fr) minmax(0, 3fr)',
                p: 0,
                m: 0,
                '& > .MuiInputLabel-root': {
                  m: 0,
                  px: { xs: 1.5, md: 2 },
                  py: { xs: 1.25, md: 1.5 },
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'var(--s-oil-surface-2)',
                  fontWeight: 700,
                  borderBottom: '1px solid var(--s-oil-border)',
                  borderRight: '1px solid var(--s-oil-border)',
                  whiteSpace: 'normal',
                  wordBreak: 'keep-all',
                  overflowWrap: 'normal',
                  lineHeight: 1.35,
                  minWidth: 0,
                },
                '& > .MuiListItem-root': {
                  m: 0,
                  px: { xs: 1.5, md: 2 },
                  py: { xs: 1.25, md: 1.5 },
                  backgroundColor: 'var(--s-oil-surface)',
                  borderBottom: '1px solid var(--s-oil-border)',
                  minWidth: 0,
                },
                '& > .MuiTypography-root': {
                  gridColumn: '1 / -1',
                  px: { xs: 1.5, md: 2 },
                  py: { xs: 1.25, md: 1.5 },
                  backgroundColor: 'var(--s-oil-surface)',
                  borderBottom: '1px solid var(--s-oil-border)',
                },
              }}>
              <InputLabel>{t('name')}</InputLabel>
              <ListItem>
                <TextField fullWidth size="small" variant="outlined" name="name" onChange={formik.handleChange} value={formik.values.name} />
              </ListItem>
              <InputLabel>{t('gender')}</InputLabel>
              <ListItem>
                <RadioGroup row onChange={formik.handleChange} value={formik.values.gender} name="gender">
                  <FormControlLabel control={<Radio />} label={t('male')} value="M" />
                  <FormControlLabel control={<Radio />} label={t('female')} value="F" />
                </RadioGroup>
              </ListItem>
              <InputLabel>{t('birth')}</InputLabel>
              <ListItem>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
                  <DatePicker sx={{ width: '100%' }} slotProps={{ textField: { size: 'small' } }} name="birthdate" value={formik.values.birthdate} onChange={(value) => formik.setFieldValue('birthdate', value, true)} />
                </LocalizationProvider>
              </ListItem>
              <InputLabel>{t('nationality')}</InputLabel>
              <ListItem>
                {i18n.language === 'en' ? (
                  <TextField fullWidth variant="outlined" size="small" name="nationality" value={formik.values.nationality} onChange={formik.handleChange} />
                ) : (
                  <RadioGroup>
                    <FormControlLabel control={<Radio />} label={t('rok')} onClick={() => setIsNationalityRok(true)} value="rok" checked={isNationalityRok === true} />
                    <FormControlLabel control={<Radio />} label={(
                      <TextField fullWidth variant="outlined" placeholder={t('other')} size="small" name="nationality" value={formik.values.nationality} onChange={formik.handleChange} disabled={isNationalityRok === true} />
                    )} value="nationality" onClick={() => setIsNationalityRok(false)} checked={isNationalityRok === false} />
                  </RadioGroup>
                )}
              </ListItem>
              {i18n.language === 'ko' && !isNationalityRok && (
                <>
                  <InputLabel>{t('nameEng')}</InputLabel>
                  <ListItem>
                    <TextField fullWidth size="small" variant="outlined" name="nameEng" onChange={formik.handleChange} value={formik.values.nameEng} />
                  </ListItem>
                </>
              )}
              <InputLabel>{t('company')}</InputLabel>
              <ListItem><TextField fullWidth size="small" variant="outlined" name="company" value={formik.values.company} onChange={formik.handleChange} /></ListItem>
              <InputLabel>{t('position')}</InputLabel>
              <ListItem><TextField fullWidth size="small" variant="outlined" name="position" value={formik.values.position} onChange={formik.handleChange} /></ListItem>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', textAlign: 'justify', wordBreak: 'keep-all', color: 'rgba(0, 0, 0, 0.6)' }}>{t('deliveryHelp').replace(/^ +/gm, '')}</Typography>
              <InputLabel>{t('address')}</InputLabel>
              <ListItem><TextField fullWidth size="small" variant="outlined" multiline name="address" value={formik.values.address} onChange={formik.handleChange} /></ListItem>
              <InputLabel>{t('officePhone')}</InputLabel>
              <ListItem><TextField fullWidth size="small" variant="outlined" name="officePhone" value={formik.values.officePhone} onChange={formik.handleChange} /></ListItem>
              <InputLabel>{t('mobilePhone')}</InputLabel>
              <ListItem><TextField fullWidth size="small" variant="outlined" name="mobilePhone" value={formik.values.mobilePhone} onChange={formik.handleChange} /></ListItem>
              <InputLabel>{t('gloveSize')}</InputLabel>
              <ListItem>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5, width: '100%' }}>
                  <Select
                    size="small"
                    name="gloveSize"
                    value={formik.values.gloveSize}
                    onChange={formik.handleChange}
                    sx={{
                      minWidth: 92,
                      '& .MuiSelect-select': {
                        fontSize: '0.875rem',
                        lineHeight: 1.4,
                      },
                    }}
                  >
                    {Array.from({ length: 9 }, (_, i) => i + 18).map((size) => (
                      <MenuItem key={size} value={size}>{size}</MenuItem>
                    ))}
                  </Select>
                  <FormControlLabel
                    control={<Checkbox checked={formik.values.gloveLeftHanded} onChange={formik.handleChange} name="gloveLeftHanded" />}
                    label={t('leftHanded')}
                    sx={{
                      maxWidth: '100%',
                      alignItems: 'center',
                      m: 0,
                      '& .MuiFormControlLabel-label': {
                        whiteSpace: 'nowrap',
                        wordBreak: 'normal',
                        overflowWrap: 'normal',
                        fontSize: { xs: '0.78rem', sm: '0.875rem' },
                      },
                    }}
                  />
                </Box>
              </ListItem>
              <InputLabel sx={{ whiteSpace: 'pre-line'}}>{t('specialMeal')}</InputLabel>
              <ListItem>
                <RadioGroup>
                  <FormControlLabel control={<Radio />} label={t('none')} onClick={() => setIsSpecialMealDisabled(true)} value="none" checked={isSpecialMealDisabled === true} />
                  <FormControlLabel control={<Radio />} label={(
                    <TextField fullWidth variant="outlined" placeholder={t('specialMealDescription')} size="small" name="specialMeal" value={formik.values.specialMeal} onChange={formik.handleChange} disabled={isSpecialMealDisabled === true} />
                  )} value="specialMeal" onClick={() => setIsSpecialMealDisabled(false)} />
                </RadioGroup>
              </ListItem>
              <Box sx={{ gridColumn: '1 / -1', px: { xs: 1.5, md: 2 }, py: 1.25, backgroundColor: 'var(--s-oil-bg-mid)', color: '#ffffff', fontWeight: 700, borderBottom: '1px solid var(--s-oil-border)' }}>
                {t('flightScheduleTitle')}
              </Box>
              <Typography variant="body2" sx={{ gridColumn: '1 / -1', whiteSpace: 'pre-line', textAlign: 'justify', wordBreak: 'keep-all', color: 'rgba(0, 0, 0, 0.6)' }}>{t('flightNotice')}</Typography>
              <InputLabel>{t('flightDeparture')}</InputLabel>
              <ListItem>
                <RadioGroup>
                  <FormControlLabel
                    control={<Radio />}
                    label={<Typography variant="body2" sx={(theme) => ({ whiteSpace: 'pre-line', wordBreak: 'normal', overflowWrap: 'normal', lineHeight: 1.45, [theme.breakpoints.down('sm')]: { fontSize: i18n.language === 'en' ? '0.62rem' : '0.75rem' } })}>{t('departureDefault')}</Typography>}
                    onClick={() => setIsDepartureDisabled(true)}
                    value="departureDefault"
                    checked={isDepartureDisabled === true}
                    sx={{ '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' } }}
                  />
                  <FormControlLabel control={<Radio />} label={(
                    <TextField fullWidth variant="outlined" placeholder={t('other')} size="small" name="flightDeparture" value={formik.values.flightDeparture} onChange={formik.handleChange} disabled={isDepartureDisabled === true} />
                  )} value="departureOther" onClick={() => setIsDepartureDisabled(false)} />
                </RadioGroup>
              </ListItem>
              <InputLabel>{t('flightArrival')}</InputLabel>
              <ListItem>
                <RadioGroup>
                  <FormControlLabel
                    control={<Radio />}
                    label={<Typography variant="body2" sx={(theme) => ({ whiteSpace: 'pre-line', wordBreak: 'normal', overflowWrap: 'normal', lineHeight: 1.45, [theme.breakpoints.down('sm')]: { fontSize: i18n.language === 'en' ? '0.62rem' : '0.75rem' } })}>{t('arrivalDefault')}</Typography>}
                    onClick={() => setIsArrivalDisabled(true)}
                    value="arrivalDefault"
                    checked={isArrivalDisabled === true}
                    sx={{ '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' } }}
                  />
                  <FormControlLabel control={<Radio />} label={(
                    <TextField fullWidth variant="outlined" placeholder={t('other')} size="small" name="flightArrival" value={formik.values.flightArrival} onChange={formik.handleChange} disabled={isArrivalDisabled === true} />
                  )} value="arrivalOther" onClick={() => setIsArrivalDisabled(false)} />
                </RadioGroup>
              </ListItem>
              <InputLabel sx={{ whiteSpace: 'pre-line' }}>{t('valetService')}</InputLabel>
              <ListItem>
                <RadioGroup>
                  <FormControlLabel control={<Radio />} label={t('use')} value="valetUsed" checked={isValetUsed === true} onClick={() => setIsValetUsed(true)} />
                  {isValetUsed === true && <TextField fullWidth variant="outlined" placeholder={t('vehicleNumber')} size="small" name="valetVehicleNumber" value={formik.values.valetVehicleNumber} onChange={formik.handleChange} sx={{ mt: 1 }} />}
                  <FormControlLabel control={<Radio />} label={t('notUse')} value="valetNotUsed" checked={isValetUsed === false} onClick={() => setIsValetUsed(false)} />
                </RadioGroup>
              </ListItem>
              <Typography variant="body2" sx={{ textAlign: 'justify', wordBreak: 'keep-all', color: 'rgba(0, 0, 0, 0.6)' }}>{t('valetNotice')}</Typography>
              </List>
            </Box>
          </CardContent>
        </Card>

        <Card className={classes.form} sx={{ mt: 2 }}>
          <CardContent>
            <Box sx={{ px: 2, py: 1.25, backgroundColor: 'var(--s-oil-surface-2)', color: '#223329', fontWeight: 700, borderBottom: '1px solid var(--s-oil-border)' }}>
              {t('privacySectionTitle')}
            </Box>
            <Box sx={{ px: 2, py: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                {t("privacyTitle")}
              </Typography>
              <Typography variant="caption" gutterBottom sx={{ whiteSpace: 'pre-wrap', textAlign: 'justify', display: 'block' }}>
                {t("privacyContent").replace(/^ +/gm, '')}
              </Typography>
              <RadioGroup sx={{ mt: 1, flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
                <FormControlLabel control={<Radio size="small" />} label={t('yes')} value="Y" onClick={() => setIsPrivacyAgreed(true)} />
                <FormControlLabel control={<Radio size="small" />} label={t('no')} value="N" onClick={() => setIsPrivacyAgreed(false)} />
              </RadioGroup>
              <Typography variant="caption" gutterBottom sx={{ whiteSpace: 'pre-wrap', textAlign: 'justify', display: 'block', mt: 2 }}>
                {t("privacyContentThirdParty").replace(/^ +/gm, '')}
              </Typography>
              <RadioGroup sx={{ mt: 1, flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
                <FormControlLabel control={<Radio size="small" />} label={t('yes')} value="Y" onClick={() => setIsThirdPartyAgreed(true)} />
                <FormControlLabel control={<Radio size="small" />} label={t('no')} value="N" onClick={() => setIsThirdPartyAgreed(false)} />
              </RadioGroup>
              <Typography variant="body2" sx={{ textAlign: 'justify', wordBreak: 'keep-all', color: 'rgba(0, 0, 0, 0.6)', mt: 2 }}>
                <b>{t('submitHelp').replace(/^ +/gm, '')}</b><br />
                {t('additional').replace(/^ +/gm, '')}<br />
                &nbsp;
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center" alignItems="stretch" gap={1.5} sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--s-oil-bg-mid)',
                    color: '#ffffff',
                    '&:hover': { backgroundColor: 'var(--s-oil-bg-top)' },
                  }}
                  fullWidth
                >
                  {t("submit")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setIsEventInfoOpen(true)}
                  sx={{
                    color: '#223329',
                    borderColor: 'var(--s-oil-bg-mid)',
                    '&:hover': {
                      borderColor: 'var(--s-oil-bg-top)',
                      backgroundColor: 'rgba(19, 100, 51, 0.08)',
                    },
                  }}
                  fullWidth
                >
                  {t("eventInfo")}
                </Button>
              </Stack>
            </Box>
          </CardContent>
        </Card>
      </div>
      <Dialog
        open={isEventInfoOpen}
        onClose={() => setIsEventInfoOpen(false)}
        fullScreen
        scroll="paper"
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setIsEventInfoOpen(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <DialogTitle>
              {t('eventInfo')}
            </DialogTitle>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <img src={i18n.language === 'ko' ? InfoKor1 : InfoEng1} alt="event-info" style={{ width: '100%' }} />
          <img src={i18n.language === 'ko' ? InfoKor2 : InfoEng2} alt="event-info" style={{ width: '100%' }} />
          <Button color="primary" onClick={() => setIsEventInfoOpen(false)} size="large" variant="contained" fullWidth sx={{ display: { xs: 'block', sm: 'none' }, mt: 2 }}>
            {t('close')}
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEventInfoOpen(false)} color="primary" sx={{ display: { xs: 'none', sm: 'block' } }} fullWidth variant="contained">
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={isAlertDialogOpen}
        onClose={() => setIsAlertDialogOpen(false)}
      >
        <DialogTitle>
          {alertTitle}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setIsAlertDialogOpen(false)}
          sx={(theme: Theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            {alertMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsAlertDialogOpen(false)} color="primary">
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
